import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const SideWrapper = styled.div`
  position: fixed;
  width: calc(50%);
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  margin-left: auto;
  z-index: 999;
  overflow: hidden;
  background-color: ${props => props.theme.color.wfWhite};
  box-shadow: rgba(0, 0, 0, 0.1) -4px 0px 12px;
  ${media.l`
    width: calc(60%);
  `};
  ${media.m`
    width: calc(80%);
  `};
  ${media.s`
    width: calc(98%);
  `};
`;

export const CloseSide = styled.div`
  display: flex;
  align-items: center;
  max-height: 48px;
  background-color: ${props => props.theme.color.wfGrey100};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  justify-content: flex-end;
  padding: 8px 16px;
  flex: 1 0 auto;
`;

export const SideContent = styled.div`
  height: 100%;
  box-sizing: inherit;
  padding: 32px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; /*needed for 'momentum' scroll on ios*/
  height: 100%; /*A value other than height:auto needs to be set*/
  ${media.s`
    padding: 16px;
  `};
`;
